import * as React from 'react';

import { api } from '../../environment';
import Table from '../../components/table/Table';
import CheckBox from '../../components/formElements/CheckBox';
import { RemoveRedEye } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import {utils, write}from 'xlsx';
import { saveAs } from 'file-saver';
import { FormDataBuilder, makeFormControls } from '../../components/formElements/util';
import Form from '../../components/formElements/Form';

export default function WeekActivitiesView(){
    const [dataRows, setDataRows] = React.useState([]);
    const [city, setCity] = React.useState(null);
    const [cities, setCities] = React.useState([])
    

    const orderData = (data)=>{
        console.log("ORDER", data)
        return data.map((row, index) =>{
            row['order'] = index+1; 
            return  row;
        })
    }

    const defineActions = (data)=>{
        return data.map((row, index)=>{
             row['action'] = <Link to={"/crs/tjedan-pregled-aktivnosti/"+row['id']}><RemoveRedEye/></Link>
             return row;
        })
    };


    const getData = (body) => {
        let call = fetch(api+"/get_activities",{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
              },
              
              body:JSON.stringify({token:localStorage.getItem('site'), criteria:filter, ...body})
            })
            try{
        return call.then(response=>response.json())
            } catch (err){
                console.log(err)
                return [];
            }
    }

    const getCities = () => {
        let call= fetch(api+"/get_active_cities", {
            method: "GET"
        })

        try {
            
            return call.then(response => response.json())

        }catch (err){
                console.log(err);
                return [];
            }
        }
    

    const header = [{name:"order", label:"#", width:"5%"},
        {name:'title', label:'Naslov događanja', width:"15%", overflowX:'scroll'},
        {name:"type", label:"Tip događanja", width:"15%"},
        {name: "city", label: "Grad/Općina", width: "10%"},
        {name:"place", label:"Mjesto", width:"10%"},
        {name:"status", label:"Status prijave", width:"5%"}, 
        {name:"action", label:"akcija", width:"5%"}, ]

    const valueMapper = (name, value) => {
        let mapping = {
            "type" : {
                1: "Predavanje",
                2: "Radionica",
                3: "Okrugli stol",
                4: "Tribina",
                5: "Izložba",
                6: "Predstavljanje",
                7: "Ostalo"
            },
            "status":{
                0: "Čeka pregled",
                1: "Poslano na recenziju",
                2: "Prihvaćeno",
                3: "Prihvaćeno uz izmjene",
                4: "Odbijeno"
            },

        }
        if(mapping[name]==undefined) return value;
        return mapping[name][value]
    }

    const mapValues = (data) =>{
        return data.map((row, index)=>{
            for(let name in row){
                row[name] = valueMapper(name,row[name])
            }
            return row
        })
    }

    const filterFormData = new FormDataBuilder()

    filterFormData
    .addTextField('title', 'Pretraži naslove', false, false, [], {flex:"1 1 20%"}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('type', 'Tip izlaganja', false, [
        {value:"0", text:'Sve'},
        {value:"1", text:"Predavanje"},
    {value:"2", text:"Radionica"},
    {value:"3", text:"Okrugli stol"},
    {value:"4", text:"Tribina"},
    {value:"5", text:"Izložba"},
    {value:"6", text:"Predstavljanje knjiga/psihologijskih mjernih instrumenata"},
    {value:"7", text:"Ostalo"},
        
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('city', 'Grad', false, cities, false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border')
    .addSelectField('status', 'Status', false, [
        {value:"-1", text:'Sve'},
        {value:'0', text:'Čeka pregled'},
        {value:'1', text:'Na recenziji'},
        {value:'2', text:'Prihvaćena'},
        {value:'3', text:'Prihvaćena uz izmjene'},
        {value:'4', text:'Odbijena'}
    ], false,[], {flex:'1 1 20%'}, null, 'input-field-no-border input-bottom-border');
    
    const [filter, setFilter] = React.useState(makeFormControls(filterFormData.get()));

    React.useEffect(()=>{
        getData().then(
            data=>setDataRows(defineActions(orderData(mapValues(data))))
        )
        
        getCities().then(
            data=>{
                setCities(()=>{
                    return data['result']
                })
            }
        )
    }, [filter])

    

    const exportToExcel = (data, fileName) => {
        const worksheet = utils.json_to_sheet(data);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(blob, `${fileName}.xlsx`);
      };

      const mutateDataForExport = (data) =>{
        const mapping = {

        }

        return data.map((row, index)=>{
            let mapping = {
                "first_name": "Ime prijavitelja",
                "last_name": "Prezime prijavitelja",
                "title":"Naslov događanja",
                "type": "Tip događanja",
                "city": "Grad",
                "status":"Status"
            }
            let mutatedRow = {}
            for(let name in mapping){
                mutatedRow[mapping[name]] = row[name]
            }
        mutatedRow["Status prijave"] = row["status"]
            console.log(row);
            return mutatedRow
        })


    }


    return (
        <>
        <h1 style={{marginBottom:"2rem"}}>Pregled prijava događanja</h1>
        <div className="input-field" style={{marginTop:"0.5rem"}}>
            <div className="flex-row" style={{gap:"1%"}}>
        <Form formData={filterFormData.get()} formControls={filter} setFormControls={setFilter}/>
        </div>
        <Table header={header} dataSource={dataRows!=undefined?dataRows:[]} layout="fixed"/>
        <button className="modal-button" style={{margin:"1rem"}}  onClick={()=>{exportToExcel(mutateDataForExport(dataRows), 'aktivnosti')}}>Izvoz u Excel</button>
        </div>
        </>
    )
}